import React from "react";
import AppText from '../atoms/AppText'
import { getWindowDimensions } from "../../HelperFunctions/index";
import { useMediaQuery } from "react-responsive";

export default function NoMessages({ height }) {
    const screenSize = getWindowDimensions()
    const isMobile = useMediaQuery({ maxWidth: 768 });

    return (
        <div className='d-flex justify-content-center w-100 align-items-center' style={{ height: screenSize.height - height }}>
            <div className={`d-flex flex-column align-items-center ${isMobile ? 'w-70' : 'w-40'}`}>
                <img alt={"message"} src='/Group-2128.svg' className={'mb-5'} height={'142'} width={'190'}></img>
                <AppText size='_18' weight='_medium' color={'_c100'}>
                    It's awfully quiet in here...
                </AppText>
                <AppText size='_16' color={'_c50'} align={'_center'}>
                    When you receive or send a message it will appear here.
                </AppText>
            </div>
        </div>
    )
}